import React from "react";
import { Container, Typography, Box, List, ListItem, ListItemIcon, ListItemText } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";

const YonetimDenetim = () => {
    return (
        <Container maxWidth="md" sx={{ py: 5 }}>
            <Box textAlign="center" mb={4}>
                <Typography variant="h4" fontWeight="bold" gutterBottom>
                    İşinizin Mali Yükünü Hafifletiyor, Sizinle Birlikte Büyüyoruz.
                </Typography>
            </Box>

            <Typography variant="h5" fontWeight="bold" gutterBottom>
                İç Denetim Hizmetleri
            </Typography>
            <Typography variant="body2" color="textPrimary" paragraph>
                Şirketlerin stratejik hedeflerini gerçekleştirmek için, bir organizasyonun risk yönetimi, kontrol ve yönetişim süreçlerini değerlendiren ve geliştiren sistematik ve disiplinli bir yaklaşımla oluşturulmuş bir iç denetim sistemine ihtiyaçları vardır. Bu nedenle, şirket yönetimleri, iç denetimin şirket organizasyonunda sağlayacağı katma değeri de göz önünde bulundurarak, en uygun maliyetlerle yüksek kalitede iç denetim hizmeti almak için profesyonel kurumlara başvurur.
            </Typography>
            <Typography variant="body2" color="textPrimary" paragraph>
                Biz, Silivri’de ve çevre ilçelerde birçok mükellefe hizmetlerimizle destek oluyoruz. Amacımız, müşterilerimize faaliyetlerinden güvence alabilmeleri için iç kontrol mekanizmalarını kurmalarında, mevcut yapılarını değerlendirmelerinde, iç denetim birimlerini kurmalarında veya mevcut iç denetim uygulamalarını geliştirmelerinde yardımcı olmaktır.
            </Typography>

            <Typography variant="h5" fontWeight="bold" gutterBottom>
                Muhasebe Organizasyonu Hizmetleri
            </Typography>
            <Typography variant="body2" color="textPrimary" paragraph>
                Muhasebe verilerinin öncelikle işletme yönetimine hizmet edecek şekilde organize edilmesi gerekmektedir. Verilerin vergi muhasebesi ve yönetim muhasebesi için farklı şekillerde ele alınması, işletmelerde karışıklıklara ve kurumsal kimlik oluşturma engellerine neden olmaktadır.
            </Typography>

            <Typography variant="h5" fontWeight="bold" gutterBottom>
                Şirket Değerleme Hizmetleri
            </Typography>
            <Typography variant="body2" color="textPrimary" paragraph>
                Şirketlerin karar verme süreçlerinde, birleşme ve satın alma işlemlerinde kullanılan fiyatın belirlenmesinde ve finansal tabloların hazırlanmasında gerçekleştirilen çalışmaların en önemlilerinden biri şirket değerinin tespitidir.
            </Typography>
            <List>
                <ListItem>
                    <ListItemIcon><CheckIcon color="success"/></ListItemIcon>
                    <ListItemText primary="Birleşme ve satın alma işlemlerinde kullanılan fiyatın belirlenmesi" primaryTypographyProps={{
                        fontWeight: 'medium',
                        variant: 'body2',
                    }}/>
                </ListItem>
                <ListItem>
                    <ListItemIcon><CheckIcon color="success"/></ListItemIcon>
                    <ListItemText primary="Şirket sermayesinin, borç yapısının ve hissedar verimliliği açısından maksimize edilmesi" primaryTypographyProps={{
                        fontWeight: 'medium',
                        variant: 'body2',
                    }}/>
                </ListItem>
                <ListItem>
                    <ListItemIcon><CheckIcon color="success"/></ListItemIcon>
                    <ListItemText primary="Şirket bölünmeleri ve birleşmelerine danışmanlık hizmeti" primaryTypographyProps={{
                        fontWeight: 'medium',
                        variant: 'body2',
                    }}/>
                </ListItem>
                <ListItem>
                    <ListItemIcon><CheckIcon color="success"/></ListItemIcon>
                    <ListItemText primary="Şirket değerinin artırılması için borç finansmanı ve yapısal borçlanma ürünleri" primaryTypographyProps={{
                        fontWeight: 'medium',
                        variant: 'body2',
                    }}/>
                </ListItem>
                <ListItem>
                    <ListItemIcon><CheckIcon color="success"/></ListItemIcon>
                    <ListItemText primary="Karlılık analizi ve optimizasyonu" primaryTypographyProps={{
                        fontWeight: 'medium',
                        variant: 'body2',
                    }}/>
                </ListItem>
                <ListItem>
                    <ListItemIcon><CheckIcon color="success"/></ListItemIcon>
                    <ListItemText primary="Uluslararası işbirliklerinin oluşturulması ve pazar analizi" primaryTypographyProps={{
                        fontWeight: 'medium',
                        variant: 'body2',
                    }}/>
                </ListItem>
                <ListItem>
                    <ListItemIcon><CheckIcon color="success"/></ListItemIcon>
                    <ListItemText primary="Yerinde denetim, tespit ve analizlerin yapılması" primaryTypographyProps={{
                        fontWeight: 'medium',
                        variant: 'body2',
                    }}/>
                </ListItem>
            </List>
        </Container>
    );
};

export default YonetimDenetim;